export default __webpack_public_path__ + "static/assets/med_gel_solid_04_b_mask.587df5fa.png";